import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const DeactivateMemberForWorkspaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeactivateMemberForWorkspace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivateMemberForWorkspace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"traceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workspaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"DeactivateMemberForWorkspace","document":DeactivateMemberForWorkspaceDocument}} as const;
export type DeactivateMemberForWorkspaceMutationVariables = Types.Exact<{
  memberId: Types.Scalars['ID']['input'];
  traceId: Types.Scalars['String']['input'];
  workspaceId: Types.Scalars['ID']['input'];
}>;


export type DeactivateMemberForWorkspaceMutation = (
  { __typename: 'Mutation' }
  & { deactivateMemberForWorkspace?: Types.Maybe<(
    { __typename: 'DeactivateMemberForWorkspace_Response' }
    & Pick<Types.DeactivateMemberForWorkspace_Response, 'id'>
  )> }
);

export type DeactivateMemberForWorkspaceMutationFn = Apollo.MutationFunction<
  DeactivateMemberForWorkspaceMutation,
  DeactivateMemberForWorkspaceMutationVariables
>;

/**
 * __useDeactivateMemberForWorkspaceMutation__
 *
 * To run a mutation, you first call `useDeactivateMemberForWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateMemberForWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateMemberForWorkspaceMutation, { data, loading, error }] = useDeactivateMemberForWorkspaceMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      traceId: // value for 'traceId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeactivateMemberForWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeactivateMemberForWorkspaceMutation,
    DeactivateMemberForWorkspaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeactivateMemberForWorkspaceMutation,
    DeactivateMemberForWorkspaceMutationVariables
  >(DeactivateMemberForWorkspaceDocument, options);
}
export type DeactivateMemberForWorkspaceMutationHookResult = ReturnType<
  typeof useDeactivateMemberForWorkspaceMutation
>;
export type DeactivateMemberForWorkspaceMutationResult =
  Apollo.MutationResult<DeactivateMemberForWorkspaceMutation>;
export type DeactivateMemberForWorkspaceMutationOptions =
  Apollo.BaseMutationOptions<
    DeactivateMemberForWorkspaceMutation,
    DeactivateMemberForWorkspaceMutationVariables
  >;
